import { PaymentMethodType } from '@nemuru-eng/js-api-client';

export const MERCHANT_POS_ALLOWED_PAYMENT_METHOD_TYPES = [
  PaymentMethodType.AUTO_LOAN,
  PaymentMethodType.CONSUMER_LOAN_INSTALMENTS,
  PaymentMethodType.CREDIT_LINE,
  PaymentMethodType.CONSUMER_LOAN_SPLIT_PAY,
];
